// Blue accent experiment from 21st.dev, kept for future comparison.
// const accentPalette = {
//   color: "#0033ff",
//   rgb: "0, 51, 255",
//   lightRgb: "51, 92, 255",
//   darkRgb: "0, 43, 214",
//   glowRgb: "51, 92, 255",
//   borderRgb: "51, 92, 255",
//   hoverRgb: "76, 112, 255",
//   scrollbarRgb: "51, 92, 255",
//   surfaceRgb: "51, 92, 255",
//   foreground: "#ffffff",
// };

const accentPalette = {
  color: "#6ad9ff",
  rgb: "106, 217, 255",
  lightRgb: "162, 242, 255",
  darkRgb: "56, 186, 226",
  glowRgb: "151, 239, 255",
  borderRgb: "160, 241, 255",
  hoverRgb: "176, 245, 255",
  scrollbarRgb: "149, 239, 255",
  surfaceRgb: "128, 232, 255",
  foreground: "#041018",
};

export const Theme = {
  colors: {
    mainFontColor: "#ffffff",
    secondaryFontColor: "rgba(255,255,255,0.62)",

    accentColor: accentPalette.color,
    accentRgb: accentPalette.rgb,
    accentLightRgb: accentPalette.lightRgb,
    accentDarkRgb: accentPalette.darkRgb,
    accentGlowRgb: accentPalette.glowRgb,
    accentBorderRgb: accentPalette.borderRgb,
    accentHoverRgb: accentPalette.hoverRgb,
    accentScrollbarRgb: accentPalette.scrollbarRgb,
    accentSurfaceRgb: accentPalette.surfaceRgb,
    accentForegroundColor: accentPalette.foreground,
    noAccentColor: "#c0c0c0",

    borderColor: "#343434",
    blockColor: "#0d0d0d",
    pageBgColor: "#080808",

    dangerColor: "#ff6b6b",
    dangerSoftColor: "rgba(255, 107, 107, 0.10)",
    dangerBorderColor: "rgba(255, 107, 107, 0.18)",

    warningColor: "#ffb84d",
    warningSoftColor: "rgba(255, 184, 77, 0.10)",
    warningBorderColor: "rgba(255, 184, 77, 0.18)",

    successColor: "#39d98a",
    successSoftColor: "rgba(57, 217, 138, 0.10)",
    successBorderColor: "rgba(57, 217, 138, 0.18)",
  },

  font: {
    fontSize1: "18px",
    fontSize2: "16px",
    fontSize3: "14px",
    fontSize4: "12px",
    fontSize5: "22px",

    fontWeight1: 700,
    fontWeight2: 600,
    fontWeight3: 500,
    fontWeight4: 400,
  },

  spacing: {
    pageX: "15px",
    pageBottom: "18px",

    card: "14px",
    cardCompact: "12px",

    sectionGap: "16px",
    blockGap: "14px",
    itemGap: "10px",
    rowGap: "8px",

    radiusLg: "20px",
    radiusMd: "16px",
    radiusSm: "14px",
    radiusXs: "12px",
  },

  media: {
    maxWidth: "768px",
  },
};
